// Fecha um Course num GameMap usando os metadados do shared.
import { mapMeta, mapMedals } from '@surfrun/shared';
import type { Course } from '../course';
import type { GameMap } from '../types';

export function finishMap(c: Course, slug: string, killDrop = 500): GameMap {
  const meta = mapMeta(slug);
  return {
    slug: meta.slug,
    name: meta.name,
    tier: meta.tier,
    credit: meta.credit,
    stages: meta.stages,
    medals: mapMedals(slug),
    env: meta.env,
    hazard: meta.hazard,
    built: c.built,
    zones: c.zones,
    stageSpawns: c.stageSpawns,
    killY: c.y - killDrop,
  };
}
